package dev.alimmz.portfolio

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.runtime.*
import androidx.compose.ui.tooling.preview.Preview
import dev.alimmz.portfolio.presentation.screen.PortfolioScreen
import dev.alimmz.portfolio.presentation.theme.PortfolioTheme

@Composable
@Preview
fun App() {
    val systemDarkTheme = isSystemInDarkTheme()
    var isDarkTheme by remember { mutableStateOf(systemDarkTheme) }

    PortfolioTheme(darkTheme = isDarkTheme) {
        PortfolioScreen(
            isDarkTheme = isDarkTheme,
            onThemeToggle = { isDarkTheme = !isDarkTheme }
        )
    }
}
